// Link do parceiro para captar clientes (#6511), com copiar e mandar no WhatsApp.
// Aparece na Visão Geral do parceiro e no Analytics do CRM. O código vem de
// profiles.codigo_indicacao, que o banco cria para todo parceiro e vendedor parceiro.
import React, { useState } from 'react';
import { Check, Copy, ExternalLink, Link2, MessageCircle } from 'lucide-react';
import { copyToClipboard, shareWhatsapp } from '../lib/clipboardShare';
import { linkDeCaptacao, mensagemDoLink } from '../lib/linkParceiro';

interface Props {
  codigo: string | null | undefined;
  /** O link é de quem está vendo (muda só o texto). */
  souEu?: boolean;
}

const botao = 'inline-flex min-h-[40px] items-center gap-1.5 rounded-lg border border-gray-200 dark:border-gray-600 bg-white dark:bg-gray-800 px-3 text-sm font-medium text-gray-700 dark:text-gray-200 hover:border-primary hover:text-primary transition-colors disabled:opacity-50';

export const LinkCaptacaoParceiro: React.FC<Props> = ({ codigo, souEu = true }) => {
  const [copiado, setCopiado] = useState(false);
  const link = codigo ? linkDeCaptacao(`${window.location.origin}${window.location.pathname}`, codigo) : '';

  const copiar = async () => {
    if (!link) return;
    try {
      await copyToClipboard(link);
      setCopiado(true);
      setTimeout(() => setCopiado(false), 2000);
    } catch {
      /* navegador sem permissão de área de transferência: o link continua visível para copiar à mão */
    }
  };

  return (
    <section aria-label="Link para captar clientes" className="rounded-2xl border border-gray-100 dark:border-gray-700 border-l-4 border-l-primary bg-white dark:bg-gray-800 p-5 shadow-sm">
      <div className="flex items-start gap-3">
        <div className="rounded-lg bg-primary/10 p-2 text-primary shrink-0"><Link2 size={18} /></div>
        <div className="min-w-0">
          <h2 className="text-sm font-bold text-gray-900 dark:text-gray-100">{souEu ? 'Seu link para captar clientes' : 'Link do parceiro para captar clientes'}</h2>
          <p className="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
            Quem deixar os dados por este link entra direto {souEu ? 'no seu CRM' : 'no CRM do parceiro'}, sem passar pelo rodízio, e o aviso chega no sino.
          </p>
        </div>
      </div>

      {link ? (
        <>
          <p className="mt-3 rounded-lg bg-gray-50 dark:bg-gray-900/50 border border-gray-200 dark:border-gray-700 px-3 py-2 font-mono text-sm text-gray-800 dark:text-gray-100 break-all select-all">
            {link}
          </p>
          <div className="mt-3 flex flex-wrap gap-2">
            <button type="button" onClick={copiar} className={botao}>
              {copiado ? <Check size={16} className="text-green-600" /> : <Copy size={16} />}
              {copiado ? 'Copiado' : 'Copiar link'}
            </button>
            <button type="button" onClick={() => shareWhatsapp(mensagemDoLink(link))} className={botao}>
              <MessageCircle size={16} /> Mandar no WhatsApp
            </button>
            <a href={link} target="_blank" rel="noopener noreferrer" className={botao}>
              <ExternalLink size={16} /> Ver a página
            </a>
          </div>
        </>
      ) : (
        <p className="mt-3 text-sm text-gray-500 dark:text-gray-400">
          O código {souEu ? 'do seu link' : 'deste parceiro'} ainda não foi criado. Avise a Tecnologia.
        </p>
      )}
    </section>
  );
};

export default LinkCaptacaoParceiro;
